"use client";

import React from "react";
import Image from "next/image";
import { ProductCardProps } from "../types";
import Button from "./Button";
import VideoCard from "./VideoCard";
import omtoIntroVideo from "../../../../../public/images/New-landing/omto_product1.mp4";

const ProductCard: React.FC<ProductCardProps> = ({
  title,
  subtitle,
  description,
  buttonText,
  image,
  layout,
  videoCard,
  onButtonClick,
  className,
}) => {
  const isLeftLayout = layout === "left";

  return (
    <div
      className={`flex flex-col ${isLeftLayout ? "lg:flex-row" : "lg:flex-row-reverse"} items-center gap-12 w-full max-w-7xl mx-auto px-6 py-12 sm:py-16 ${className || ""}`}
    >
      <div className="w-full lg:flex-1 space-y-4 text-center lg:text-left">
        <h2 className="text-omto-blue font-montserrat font-bold text-[22px] sm:text-[27px] leading-snug">
          {title}
        </h2>

        <h3 className="text-omto-dark font-montserrat font-semibold text-[28px] sm:text-[36px] leading-snug">
          {subtitle}
        </h3>

        <p className="text-omto-dark text-justify font-montserrat font-medium text-[16px] sm:text-[18px] leading-relaxed tracking-wide pt-4">
          {description}
        </p>

        {buttonText && (
          <div className="pt-4 flex justify-center lg:justify-start">
            <Button
              variant="secondary"
              size="lg"
              href="#contact"
              onClick={onButtonClick}
              className="px-16 py-4 min-w-[300px] sm:min-w-[380px] text-center"
            >
              {buttonText}
            </Button>
          </div>
        )}
      </div>

      <div className="w-full lg:flex-1 flex flex-col items-center gap-8">
        {videoCard ? (
          <VideoCard
            thumbnail={videoCard.thumbnail}
            videoSrc={videoCard.videoSrc || omtoIntroVideo}
            youtubeUrl={videoCard.youtubeUrl}
          />
        ) : (
          <Image
            src={image}
            alt={title}
            className="w-[70%] max-w-sm lg:max-w-lg h-auto"
            width={600}
            height={400}
            quality={100}
            priority={false}
          />
        )}
      </div>
    </div>
  );
};

export default ProductCard;
